export function createClientTypedResponsePromise(response$) {
    return new Proxy(response$, {
        get(target, key, receiver) {
            if (key === 'json') {
                return () => target.then(res => res.json());
            }
            const value = Reflect.get(target, key, receiver);
            if (typeof value === 'function') {
                return value.bind(target);
            }
            return value;
        },
        has(target, key) {
            if (key === 'json') {
                return true;
            }
            return Reflect.has(target, key);
        },
    });
}
